import { render, staticRenderFns } from "./crudSensorsAssociateTankCustomer.vue?vue&type=template&id=3d24116e&"
import script from "./crudSensorsAssociateTankCustomer.vue?vue&type=script&lang=js&"
export * from "./crudSensorsAssociateTankCustomer.vue?vue&type=script&lang=js&"
import style0 from "./crudSensorsAssociateTankCustomer.vue?vue&type=style&index=0&id=3d24116e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports